'use client';

import { c as _c } from "react/compiler-runtime";
import { parseTime } from '@internationalized/date';
import { InputTime } from '@xefi/x-react/form';
import type { InputFieldProps } from '@/models/inputFields';
type HourFieldProps = InputFieldProps<string>;
export const HourField = t0 => {
  const $ = _c(8);
  const {
    value,
    onChange,
    readonly
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = value ? parseTime(value) : undefined;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const inputValue = t1;
  let t2;
  if ($[2] !== onChange) {
    t2 = value_0 => {
      if (value_0) {
        const hours = String(value_0.hour).padStart(2, "0");
        const minutes = String(value_0.minute).padStart(2, "0");
        onChange?.(`${hours}:${minutes}`);
      } else {
        onChange?.("");
      }
    };
    $[2] = onChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== inputValue || $[5] !== readonly || $[6] !== t2) {
    t3 = <InputTime value={inputValue} onChange={t2} isDisabled={readonly} granularity="minute" hourCycle={24} />;
    $[4] = inputValue;
    $[5] = readonly;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};